import React, { PropsWithChildren } from 'react'

import { SideSelectContainerProps } from './SideSelectContainer.model'

import styles from './SideSelectContainer.module.scss'

export function SideSelectContainer({ children }: PropsWithChildren<SideSelectContainerProps>) {
  return <div className={styles.container}>{children}</div>
}
